export const blobUrlToFile = async (blobUrl: string, filename: string) => {
  const res = await fetch(blobUrl);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type });
};

export const saveFileToOPFS = async (file: File, filename: string): Promise<string> => {
  try {
    const opfsRoot = await navigator.storage.getDirectory();
    const fileHandle = await opfsRoot.getFileHandle(filename, { create: true });
    const writable = await fileHandle.createWritable();
    await writable.write(file);
    await writable.close();
    return filename;
  } catch (error) {
    console.error("Failed to save file to OPFS:", error);
    throw error;
  }
};

export const getFileFromOPFS = async (filename: string): Promise<File | null> => {
  try {
    const opfsRoot = await navigator.storage.getDirectory();
    const fileHandle = await opfsRoot.getFileHandle(filename);
    const file = await fileHandle.getFile();
    return file;
  } catch (error) {
    console.error("Failed to get file from OPFS:", error);
    return null;
  }
};

export const deleteFileFromOPFS = async (filename: string): Promise<boolean> => {
  try {
    const opfsRoot = await navigator.storage.getDirectory();
    await opfsRoot.removeEntry(filename);
    return true;
  } catch (error) {
    console.error("Failed to delete file from OPFS:", error);
    return false;
  }
};
